export const NEIGHBORHOOD_RESIDENTIAL_SUBDIVISION_LEVEL = 4
export const NEIGHBORHOOD_SUB_LEVEL = 3
export const NEIGHBORHOOD_DEFAULT_LEVEL = 2
export const NEIGHBORHOOD_MACRO_LEVEL = 1
